import React, { useContext, useEffect, useReducer, useState } from 'react'
import axios from 'axios'
import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'
import { useSubscription } from '../../hooks/SuperAdmin/useSubscription'
import { useRazorPay } from '../../hooks/razorPay/useRazorPay'
import { toastMessage } from '../../shared/AlertPopup'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { API, backendUrl, tmpOrderUrl } from '../../shared/API'

export default function Subscriptions() {
  const { getAllSubscriptions, loading, paginate, updateSubscription, activeSubscriptions, deleteMany, pdfCsvData, active: activeSubs, downloadLoading } = useSubscription()
  const { loadRazorpay, purchaseSubscription, trySubscription } = useRazorPay()
  const { superAdmins, subscriptions, addSubscription } = useContext(SuperAdminContext)
  const [currentPrice, setCurrentPrice] = useState(0)
  const user = useContext(UserContext)
  //console.log('superAdmins : ', superAdmins)
  const history = useHistory()
  const token = user && user.token
  const header = formTokenHeader(token)
  const isCompanyAdmin = user && user.user.userType === 'COMPANYADMIN'
  const [searchQuery, setSearchQuery] = useState('')
  const [text, setText] = useState('Renew')
  // const filterSuperAdmin = superAdmins
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllSubscriptions({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getAllSubscriptions({
      page: page,
      limit: 10,
    })
    activeSubscriptions()
    console.log('SUBSCRIPTIONS', subscriptions.subscriptions)
  }, [])

  useEffect(() => {
    console.log('currentPrice ', activeSubs?.subscription?.amount)
    activeSubs?.subscription?.trial === false && setCurrentPrice(activeSubs?.subscription?.amount)
  }, [activeSubs])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const handleSwitchChange = (item) => updateSubscription({ ...item, active: !item.active })
  const handleClick = (event, item) => {
    event.preventDefault()
    if (activeSubs) {
      if (activeSubs.subscription._id === item._id) {
        if (activeSubs.trial === true) {
          loadRazorpay({ amount: item.amount, subscriptionId: item._id, header: header, validityPeriod: item.validityPeriod, purchaseId: activeSubs._id })
        }
      } else {
        trySubscription({ amount: item.amount, subscriptionId: item._id, header: header, validityPeriod: item.validityPeriod })
      }
    } else {
      trySubscription({ amount: item.amount, subscriptionId: item._id, header: header, validityPeriod: item.validityPeriod })
    }
    localStorage.clear()
  }

  const getText = (item) => {
    if (user.user.userType === 'SUPERADMIN') return 'Buy'
    else if (activeSubs) {
      if (activeSubs.subscription._id === item._id) {
        if (activeSubs.trial === true) {
          return 'In Trial'
        } else {
          //it is disabled
          return 'Purchased'
        }
      } else {
        if (activeSubs.subscription.amount > item.amount) {
          return 'Downgrade'
        } else {
          return 'Upgrade'
        }
      }
    } else {
      return 'Buy'
    }
  }

  const getDisabled = (item) => {
    if(isPurchased(item._id)) return true;
    if (user.user.userType === 'SUPERADMIN') return true
    else if (activeSubs) {
      console.log({ activeSubs })
      if (activeSubs.subscription._id === item._id) {
        if (activeSubs.trial === true) {
          return false
        } else {
          return true
        }
      }
    } else {
      return false
    }
  }
  let tableBody = []

  const isPurchased = (id) => {
    let flag = 0
    if (activeSubs?.subscription?._id == id && activeSubs?.subscription?.trial == false) {
      flag = 1
    } else if (activeSubs?.subscription?._id == id && activeSubs?.subscription?.trial == true) {
      setText('Buy Trial')
    }
    return flag
  }
  console.log(subscriptions.subscriptions)
  if (!loading && subscriptions.subscriptions.length > 0) {
    tableBody = subscriptions.subscriptions.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.subscriptionName },
        { value: item.description },
        { value:(typeof item.modules.allowed == "object" ? item.modules.allowed.map((allowed)=>{
          return allowed.module
        }) : "") },
        { value: item.amount },
        { value: item.discount['$numberDecimal'] + '%' },
        { value: item.amount * (1 - 0.01 * parseFloat(item.discount['$numberDecimal'])) },
        { value: item.userLicense },
        { value: item.validityPeriod + ' months' },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        {
          type: 'BUTTON',
          disabled: getDisabled(item),
          text: getText(item),
          onClick: (e) => {
            handleClick(e, item)
          },
        },
      ]
    })
  }

  const layoutProps = {
    heading: 'Subscriptions',
    url: ROUTES.ADD_SUBSCRIPTION_PLAN,
    editUrl: `/super-admin/subscription-plans/edit/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'subscriptions',
    sheetName: 'subscriptions',
    headers: pdfCsvData.headings,
    // permission: "SUPERADMIN",
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'SUBSCRIPTIONS',
    sampleName: 'subscriptions',
    addData: addSubscription,
    setPage,
    tempHeaders: ['discount', 'description', 'active', 'validityPeriod', 'amount', 'subscriptionName', 'modules', 'createdAt'],
    tempHeaderData: [['2', 'Description of the subscription', '1', '3 (in months)', '1000', 'TEMP_NAME', 'AUDIT_EMPLOYEE', '01-01-2022']],
    allow: true,
  }

  useEffect(() => {
    // loadScript("");
  })

  return (
    <CustomTableLayout
      tableHeadings={['Subscription Name', 'Description', 'Permissions', 'Amount', 'Discount', 'Discounted Price', 'User Licences', 'Validity Period', 'Created At', 'Active Status', 'Buy']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteMany({ ids: val }, setSelected)}
      // deleteMany={(val, setSelected) => deleteManySuperAdmin({ companyId: val }, setSelected)}
    />
  )
}
